var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNationalAndInternationalNews = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Microphone-Podcast-International-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Microphone Podcast International 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7a6.75 6.75 0 1 0 -11.52 4.52 0.22 0.22 0 0 0 0.23 0.06 0.23 0.23 0 0 0 0.17 -0.17 4.58 4.58 0 0 1 2.65 -3.05 0.25 0.25 0 0 0 0.12 -0.36l-0.4 -0.82c-0.06 -0.13 0 -0.28 0 -0.43a2 2 0 0 0 -2 -2h-0.47a0.24 0.24 0 0 1 -0.21 -0.12 0.23 0.23 0 0 1 0 -0.24A5.18 5.18 0 0 1 8.29 3a5.24 5.24 0 0 1 6.06 -1 0.23 0.23 0 0 1 0.13 0.26 0.25 0.25 0 0 1 -0.23 0.18 2 2 0 0 0 0 4h0.25a0.75 0.75 0 0 1 0.75 0.75 2.25 2.25 0 0 0 1.11 1.94 0.25 0.25 0 0 1 0.12 0.16 0.22 0.22 0 0 1 0 0.19 5 5 0 0 1 -0.44 0.59 0.26 0.26 0 0 0 0 0.28 3.83 3.83 0 0 1 0.38 1 0.26 0.26 0 0 0 0.18 0.17 0.23 0.23 0 0 0 0.24 -0.06A6.68 6.68 0 0 0 18.75 7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.54a3 3 0 0 0 -3 2.93v2.84a3 3 0 0 0 6 0v-2.84a3 3 0 0 0 -3 -2.93Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.75v1.5a4.25 4.25 0 0 1 -8.5 0v-1.5a0.75 0.75 0 0 0 -1.5 0v1.5A5.76 5.76 0 0 0 11 20.92a0.25 0.25 0 0 1 0.21 0.24v1.09a0.25 0.25 0 0 1 -0.25 0.25H8A0.75 0.75 0 0 0 8 24h8a0.75 0.75 0 0 0 0 -1.5h-3a0.25 0.25 0 0 1 -0.25 -0.25v-1.09a0.25 0.25 0 0 1 0.21 -0.24 5.77 5.77 0 0 0 4.79 -5.67v-1.5a0.75 0.75 0 0 0 -1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNationalAndInternationalNews);
export default ForwardRef;